import axios from 'axios';
import { property } from 'lodash';

import { mapLocalStylingToApiModel } from 'styling/api/dataMapper/surveyStylingDataMapper';
import defaultLocalStyling from 'styling/config/defaultLocalStyling';

import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';

import { mapTemplateDataForEditor } from './dataMapper/mapTemplateDataFromApi';
import CreateTemplateSubmissionErrors from '../submissionErrors/CreateTemplateSubmissionErrors';
import { TEMPLATE_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

export default () =>
  axios
    .post(buildApiV2Url(TEMPLATE_TYPE_COLLECTION_PATH), {
      local_styles: mapLocalStylingToApiModel(defaultLocalStyling),
    })
    .catch(
      generateApiError({ submissionErrorMap: CreateTemplateSubmissionErrors }),
    )
    .then(property('data'))
    .then(mapTemplateDataForEditor);
